module.exports = __webpack_public_path__ + "img/jonathan_i.4128ef0c.jpg";